import * as React from 'react';
import { styled } from '@mui/material/styles';

export interface CardProps {
    children?: React.ReactNode | React.ReactNode[];
    cardSx?: object;
    onClick?: () => void;
}

export const Card = ({ children, cardSx }: CardProps) => {
    const StyledCard = styled('div')(({ theme }) => ({
        borderRadius: '12px',
        border: `1px solid ${theme.palette.semantic.bd.default}`,
        background: theme.palette.semantic.bg.default,
        boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.05)',
        padding: '24px',
        marginBottom: '24px',
        ...cardSx
    }));

    return <StyledCard>{children}</StyledCard>;
};
